import React from "react";
import { Box, Grid, Typography, Link, IconButton } from "@mui/material";
import OurApps from "../../assets/img/OurApps.png";
import facebook1 from "../../assets/img/facebook1.png";
import instagram1 from "../../assets/img/instagram1.png";
import twitter1 from "../../assets/img/twitter1.png";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "#0B2C39",
        color: "#C7E7FF",
        padding: "2rem 4rem",
        marginTop: "15vh",
        position: "relative",
      }}
    >
      <Grid container spacing={4} justifyContent="center">
        {/* Sales Person Section */}
        <Grid item xs={12} md={3} textAlign="center">
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: "#C7E7FF",
              wordSpacing: "0.1rem",
              letterSpacing: "0.05rem",
              marginBottom: "3vh",
            }}
          >
            Our Sales Person
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "0.3rem",
              alignItems: "center",
            }}
          >
            {[
              { phone: "+91 9601117624", location: "Kanan Vihar" },
              { phone: "+91 9601117624", location: "Sailashree Vihar" },
              { phone: "+91 9601117624", location: "Raghunathpur" },
              { phone: "+91 9178612840", location: "Mancheswar" },
              { phone: "+91 9178612840", location: "Chandrasekharpur" },
            ].map((salesperson, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  maxWidth: "20rem",
                }}
              >
                <Typography>{salesperson.phone}</Typography>
                <Typography>{salesperson.location}</Typography>
              </Box>
            ))}
          </Box>
        </Grid>

        {/* Social Links Section */}
        <Grid
          item
          xs={12}
          md={3}
          textAlign="center"
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: "#C7E7FF",
              wordSpacing: "0.1rem",
              letterSpacing: "0.05rem",
            }}
          >
            Social Links
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <IconButton
              component="a"
              href="https://www.facebook.com/profile.php?id=61568864636362"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "#C7E7FF" }}
            >
              <img src={facebook1} alt="Facebook" />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.instagram.com/drips_water/profilecard/?igsh=MXEzOG81aTVtZjBnZg=="
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "#C7E7FF" }}
            >
              <img src={instagram1} alt="Instagram" />
            </IconButton>
            <IconButton
              component="a"
              href="https://twitter.com/drips_water"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "#C7E7FF" }}
            >
              <img src={twitter1} alt="Twitter" />
            </IconButton>
          </Box>
        </Grid>

        {/* Address Section */}
        <Grid item xs={12} md={3} textAlign="center">
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: "#C7E7FF",
              wordSpacing: "0.2rem",
              letterSpacing: "0.05rem",
              textAlign: "left",
              marginLeft: "4rem",
            }}
          >
            Our Address
          </Typography>
          <Typography
            sx={{
              color: "#C7E7FF",
              padding: "1rem",
              wordSpacing: "0.2rem",
              letterSpacing: "0.07rem",
              textAlign: "left",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            AADI MANUFACTURING PVT Ltd <br />
            Plot No- 952 Patharagadia <br />
            Near KIIT Square PIN- 751025 <br />
            Bhubaneswar, Odisha
          </Typography>
        </Grid>

        {/* Apps Section */}
        <Grid
          item
          xs={12}
          md={3}
          textAlign="center"
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: "#C7E7FF",
              wordSpacing: "0.1rem",
              letterSpacing: "0.05rem",
            }}
          >
            Our Apps
          </Typography>
          <Box>
            <img
              src={OurApps}
              alt="Google Play"
              style={{
                width: "380px",
                height: "210px",
              }}
            />
          </Box>
        </Grid>
      </Grid>

      {/* Footer Bottom Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "0.5rem",
          paddingTop: "1rem",
          borderTop: "1px solid rgb(41, 68, 104)",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#C7E7FF",
          }}
        >
          © 2024 Drips Water. All rights reserved.
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Link
            onClick={() => navigate("/DeleteAccount")}
            sx={{
              color: "#C7E7FF",
              textDecoration: "none",
              fontSize: "0.9rem",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Delete Account
          </Link>
          <Typography sx={{ color: "#C7E7FF" }}>|</Typography>
          <Link
            onClick={() => navigate("/PrivacyPolicy")}
            sx={{
              color: "#C7E7FF",
              textDecoration: "none",
              fontSize: "0.9rem",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Privacy Policy
          </Link>
          <Typography sx={{ color: "#C7E7FF" }}>|</Typography>
          <Link
            onClick={() => navigate("/TermsConditions")}
            sx={{
              color: "#C7E7FF",
              textDecoration: "none",
              fontSize: "0.9rem",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Terms and Conditions
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
